// extracted by mini-css-extract-plugin
export default {"button":"BaseButton_button__s5rH6","buttonProgressWrapper":"BaseButton_buttonProgressWrapper__IGTQe"};